import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Player from 'experium-player';
import PlayerLegacy from 'experium-player-legacy';
import counterpart from 'counterpart';
import { assocPath, path } from 'ramda';
import Translate from 'react-translate-component';

import { getToken } from 'utils/token';
import { BASE_URL } from 'constants/urls';
import { sendSaveButton } from 'utils/script';

export default class DocumentScript extends Component {
    static propTypes = {
        onComplete: PropTypes.func,
        onAbort: PropTypes.func,
        body: PropTypes.object.isRequired,
        options: PropTypes.object,
        cmd: PropTypes.string,
        button: PropTypes.object,
    };

    static defaultProps = {
        cmd: 'DoWebSupport',
        button: sendSaveButton,
    }

    render() {
        const { onComplete, onAbort, body, options, cmd, button } = this.props;

        const bodyWithButton = assocPath(['options', 'buttons', 'send'], button, body);
        const isLegacy = path(['options', 'version'], body);
        const Script = isLegacy ? PlayerLegacy : Player;

        return (
            <div className={`player ${isLegacy ? 'legacy' : 'last'}`}>
                { body && (
                    <Script
                        baseUrl={`${BASE_URL}/v1/os/script/`}
                        baseUrlParams={`?token=${getToken()}&cmd=${cmd}`}
                        onComplete={onComplete}
                        data={bodyWithButton}
                        options={options}
                        onAbort={onAbort}
                        language={counterpart.getLocale()}
                        completeButtonTitle={onAbort ? undefined : <Translate content="events.save" />}
                    />
                )}
            </div>
        );
    }
}
